declare module '@mui/material/styles' {
	interface Palette {
		navbar: {
			primary: {
				main: string;
				active: string;
			};
			secondary: {
				main: string;
				active: string;
			};
		},
		border: {
			primary: string
		};
	}
	interface PaletteOptions {
		navbar?: {
			primary?: {
				main?: string;
				active?: string;
			};
			secondary?: {
				main?: string;
				active?: string;
			};
		};
	}
}

export const palette = {
	background: {
		default: '#2B27280A',
		paper: '#EAECF3',
	},
	primary: {
		main: '#ff0e38',
	},
	secondary: {
		main: '#2B2728',
		contrast: '#FFFFFF',
	},
	navbar: {
		primary: {
			main: '#ff0e38',
			active: '#ff0e38',
		},
		secondary: {
			main: '#fff',
			active: '#DC2C35',
		},
	},
	text: {
		primary: '#161616',
		secondary: '#161616',
		disabled: '#84858a',
	},
	action: {
		disabled: '#f1f1f3'
	},
	border: {
		primary: '#EAF0F1',
	}
};
